/* Motor da Busca Inteligente MakNorte — compartilhado pela página /search (mn-smart-search)
 * e pela lupa do cabeçalho (mn-predictive). Publicado como assets/mn-search-engine.js.
 *
 * API: window.MNSearch = { norm, build(db), search(query) -> {items, expanded, approx} }
 * Regras de busca:
 *  - palavras "fortes" (nome do equipamento) precisam bater (E); números, unidades e
 *    qualificadores (litros, 220v, industrial, usado...) só dão bônus — não zeram a busca
 *  - sinônimo SOMA à palavra digitada (quem digita "geladeira" vê também as Geladeiras Esmaltec)
 *  - se nenhum produto bater em todas as palavras fortes, mostra os que batem em pelo menos uma
 *    (approx=true) em vez de "nada encontrado"
 *  - tolerância a erro de digitação (Levenshtein), peças/acessórios vão para o fim
 */
(function () {
  'use strict';
  if (window.MNSearch) { return; }

  var STOP = { de: 1, da: 1, do: 1, das: 1, dos: 1, para: 1, pra: 1, com: 1, sem: 1, e: 1, a: 1, o: 1, as: 1, os: 1,
    em: 1, no: 1, na: 1, nos: 1, nas: 1, ao: 1, um: 1, uma: 1 };
  var FILLER = { maquina: 1, maquininha: 1, aparelho: 1, equipamento: 1, equipamentos: 1, fazer: 1, fabricar: 1,
    fabrica: 1, modelo: 1, tipo: 1, quero: 1, preciso: 1, montar: 1, montando: 1, montagem: 1, abrir: 1,
    equipar: 1, equipando: 1, comprar: 1, vendo: 1, venda: 1, preco: 1, valor: 1, barato: 1, barata: 1,
    promocao: 1, oferta: 1 };
  // Qualificadores: ajudam a ordenar, mas nunca eliminam resultado
  var SOFT = { litros: 1, litro: 1, lts: 1, lt: 1, l: 1, ml: 1, kg: 1, g: 1, cm: 1, mm: 1, m: 1, metro: 1, metros: 1,
    industrial: 1, comercial: 1, profissional: 1, grande: 1, pequeno: 1, pequena: 1, medio: 1, media: 1,
    usado: 1, usada: 1, usados: 1, seminovo: 1, seminova: 1, novo: 1, nova: 1,
    '220v': 1, '127v': 1, '110v': 1, '380v': 1, bivolt: 1, volts: 1, monofasico: 1, trifasico: 1,
    inox: 1, branco: 1, branca: 1, preto: 1, preta: 1, cinza: 1 };
  var PART_PENALTY = 140, AVAIL_BONUS = 14, LEAD_BONUS = 30, SOFT_WEIGHT = 0.6, SYN_PENALTY = 12;

  var DB = null, SYN = {};

  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function lev(a, b) {
    if (a === b) { return 0; }
    var m = a.length, n = b.length;
    if (!m) { return n; }
    if (!n) { return m; }
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) { prev[j] = j; }
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      var t = prev; prev = cur; cur = t;
    }
    return prev[n];
  }

  function isNumeric(t) { return /^\d+[a-z]{0,2}$/.test(t); }
  function isHard(t) { return t.length >= 3 && !isNumeric(t) && !SOFT[t]; }

  // Quanto o termo "term" casa com o produto p (0..100). isSyn = veio de sinônimo (vale um pouco menos).
  function tokScore(term, p, isSyn) {
    if (!term) { return 0; }
    var best = 0, i, tt, st;
    for (i = 0; i < p._tt.length; i++) {
      tt = p._tt[i];
      if (tt === term) { best = 100; break; }
      if (tt.length >= 3 && term.length >= 3 && (tt.indexOf(term) === 0 || term.indexOf(tt) === 0)) { if (best < 90) { best = 90; } }
    }
    if (best < 70 && term.length >= 4 && p._t.indexOf(term) >= 0) { best = 70; }
    if (best < 55) {
      for (i = 0; i < p._st.length; i++) {
        st = p._st[i];
        if (st === term) { if (best < 55) { best = 55; } break; }
        if (st.length >= 3 && term.length >= 3 && (st.indexOf(term) === 0 || term.indexOf(st) === 0)) { if (best < 50) { best = 50; } }
      }
    }
    if (best === 0 && !isSyn && term.length >= 4 && !isNumeric(term)) {
      var md = 99;
      for (i = 0; i < p._tt.length; i++) {
        tt = p._tt[i];
        if (Math.abs(tt.length - term.length) <= 2) { var d = lev(tt, term); if (d < md) { md = d; } }
      }
      var thr = term.length >= 7 ? 2 : 1;
      if (md <= thr) { best = 52 - md * 12; }
    }
    return isSyn ? Math.max(0, best - SYN_PENALTY) : best;
  }

  function groupFor(tk) {
    var g = [{ term: tk, syn: false }];
    (SYN[tk] || []).forEach(function (s) { s.split(' ').forEach(function (w) { if (w) { g.push({ term: w, syn: true }); } }); });
    return g;
  }

  // Monta os grupos: cada grupo é uma lista OR de termos; hard=true precisa casar.
  function plan(query) {
    var qn = norm(query);
    if (!qn) { return null; }
    var tokens = qn.split(' ').filter(function (t) { return t && !STOP[t] && !FILLER[t]; });
    var phrase = SYN[qn] || SYN[tokens.join(' ')] || null;
    var groups = [], expanded = null;
    if (phrase) {
      // frase conhecida: um grupo OR com os sinônimos + as palavras digitadas; cada palavra digitada vira bônus
      var g = [];
      tokens.forEach(function (t) { g.push({ term: t, syn: false }); });
      phrase.forEach(function (s) { s.split(' ').forEach(function (w) { if (w) { g.push({ term: w, syn: true }); } }); });
      groups.push({ terms: g, hard: true });
      tokens.forEach(function (t) { if (t.length >= 3) { groups.push({ terms: [{ term: t, syn: false }], hard: false }); } });
      expanded = phrase;
    } else {
      tokens.forEach(function (tk) {
        groups.push({ terms: groupFor(tk), hard: isHard(tk) });
        if (!expanded && SYN[tk]) { expanded = SYN[tk]; }
      });
    }
    if (!groups.length) { return null; }
    var hard = groups.filter(function (g) { return g.hard; });
    if (!hard.length) { groups.forEach(function (g) { g.hard = true; }); } // só números/qualificadores: pelo menos um deve casar
    return { groups: groups, expanded: expanded };
  }

  function scoreProduct(p, groups, needAllHard) {
    var total = 0, hardHit = 0, hardCount = 0, j, k, gs, g;
    for (j = 0; j < groups.length; j++) {
      g = groups[j]; gs = 0;
      for (k = 0; k < g.terms.length; k++) {
        var s = tokScore(g.terms[k].term, p, g.terms[k].syn);
        if (s > gs) { gs = s; }
      }
      if (g.hard) {
        hardCount++;
        if (gs > 0) { hardHit++; total += gs; } else if (needAllHard) { return null; }
      } else {
        total += gs * SOFT_WEIGHT;
      }
    }
    if (hardCount && !hardHit) { return null; }
    if (!needAllHard) { total = total * hardHit / hardCount; }
    return total;
  }

  function search(query) {
    var pl = plan(query);
    if (!pl || !DB) { return { items: [], expanded: null, approx: false }; }
    var leadTerms = [];
    pl.groups.forEach(function (g) { g.terms.forEach(function (x) { if (x.term.length >= 3) { leadTerms.push(x.term); } }); });
    var run = function (needAllHard) {
      var out = [], i, j;
      for (i = 0; i < DB.products.length; i++) {
        var p = DB.products[i];
        var total = scoreProduct(p, pl.groups, needAllHard);
        if (total === null) { continue; }
        var lead = p._tt[0] || '';
        for (j = 0; j < leadTerms.length; j++) {
          var t = leadTerms[j];
          if (lead === t || lead.indexOf(t) === 0 || t.indexOf(lead) === 0) { total += LEAD_BONUS; break; }
        }
        if (p.av) { total += AVAIL_BONUS; }
        if (p.part) { total -= PART_PENALTY; }
        out.push([total, p]);
      }
      out.sort(function (a, b) { return b[0] - a[0] || (a[1].part - b[1].part); });
      return out.map(function (x) { return x[1]; });
    };
    var items = run(true), approx = false;
    var hardCount = pl.groups.filter(function (g) { return g.hard; }).length;
    if (!items.length && hardCount >= 2) { items = run(false); approx = items.length > 0; }
    return { items: items, expanded: pl.expanded, approx: approx };
  }

  function build(db) {
    DB = db;
    DB.suggest = DB.suggest || [];
    DB.popular = DB.popular || [];
    SYN = {};
    for (var k in DB.synonyms) { if (Object.prototype.hasOwnProperty.call(DB.synonyms, k)) { SYN[norm(k)] = DB.synonyms[k].map(norm); } }
    DB.products.forEach(function (p) {
      p._t = norm(p.t);
      p._tt = p._t.split(' ').filter(Boolean);
      p._s = norm([p.pt, p.v, p.tg].join(' '));
      p._st = p._s.split(' ').filter(Boolean);
    });
    return DB;
  }

  // Imagem que falhou: tenta de novo 3x; se continuar falhando, mostra um marcador neutro em vez de ícone quebrado
  function imgRetry(im) {
    var n = (im.__r || 0) + 1; im.__r = n;
    var s = im.getAttribute('src');
    if (n > 3 || !s) {
      im.onerror = null;
      var ph = document.createElement('div');
      ph.className = 'mn-noimg';
      ph.setAttribute('aria-hidden', 'true');
      ph.textContent = '📦';
      if (im.parentNode) { im.parentNode.replaceChild(ph, im); }
      return;
    }
    im.removeAttribute('src');
    setTimeout(function () { im.setAttribute('src', s); }, 450 * n);
  }

  window.MNSearch = { norm: norm, build: build, search: search, imgRetry: imgRetry, STOP: STOP, FILLER: FILLER, SOFT: SOFT };
  window.mnImgRetry = imgRetry;
  try { document.dispatchEvent(new CustomEvent('mn-engine-ready')); } catch (e) { /* navegador antigo */ }
})();
